import { render, staticRenderFns } from "./professionalDetail.vue?vue&type=template&id=39fdc924&scoped=true"
import script from "./professionalDetail.vue?vue&type=script&lang=js"
export * from "./professionalDetail.vue?vue&type=script&lang=js"
import style0 from "./professionalDetail.vue?vue&type=style&index=0&id=39fdc924&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fdc924",
  null
  
)

export default component.exports